import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HeaderConfiguration } from 'src/app/shared/components/header/header.component';
import { Title } from 'src/app/shared/components/title/title.component';

@Injectable()
export class JsonConfiguration {
  titleData: Title;
  headerConfiguration: HeaderConfiguration;
  
  confirmDialogConfig = {
    title: '¡Hecho!',
    subtitle:
      'Hemos enviado un SMS al cliente para que rellene sus datos y finalice con el proceso',
    buttonText: 'Cerrar',
    icon: 'checkCircle',
  };
  
  errorDialogConfig = {
    title: 'Vaya...',
    subtitle:
      "Parece que se ha producido un error. Inténtalo de nuevo en unos minutos, si necesitas ayuda ponte en contacto con nosotros a través de <a hre:'mailto:ayuda@ingood.es'>ayuda@ingood.es</a>",
    buttonText: 'Cerrar',
    icon: 'closeCircleErr',
  };

  constructor(private translateService: TranslateService) {
    this.setTitleData();
    this.setHeaderConfiguration();
  }

  private setTitleData(): void {
    this.titleData = {
      title: 'dasda',
    };

    this.translateService.get('superGuarantee.title').subscribe((res) => {
      this.titleData.title = res;
    });
  }

  private setHeaderConfiguration(): void {
    this.headerConfiguration = {
      layoutAlign: 'start start',
      sections: [
        {
          partner: true,
          menu: true,
        },
      ],
    };
  }
}
